/** Audio file metadata shared by desktop browsers and iPhone Safari. */
export function chooseAudioMimeType(
  Recorder = typeof window !== 'undefined' ? window.MediaRecorder : undefined,
  userAgent = typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''
) {
  if (!Recorder || typeof Recorder.isTypeSupported !== 'function') return '';
  // Prefer AAC/MP4 on iPhone/Safari. Preserve WebM preference on Chrome/Firefox.
  const safari = /iPhone|iPad|iPod/i.test(userAgent) ||
    (/Safari/i.test(userAgent) && !/Chrome|Chromium|Edg|OPR/i.test(userAgent));
  const candidates = safari
    ? ['audio/mp4', 'audio/webm;codecs=opus', 'audio/webm', 'audio/ogg;codecs=opus', 'audio/ogg']
    : ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus', 'audio/ogg'];
  for (const mimeType of candidates) {
    if (Recorder.isTypeSupported(mimeType)) return mimeType;
  }
  return ''; // Let the browser choose if it doesn't recognize any candidate.
}

export function audioFilename(mimeType) {
  const base = (mimeType || '').split(';')[0].trim().toLowerCase();
  const extensions = {
    'audio/mp4': 'm4a',
    'audio/x-m4a': 'm4a',
    'audio/webm': 'webm',
    'audio/ogg': 'ogg',
    'audio/wav': 'wav',
    'audio/wave': 'wav',
    'audio/mpeg': 'mp3',
  };
  return `recording.${extensions[base] || 'bin'}`;
}

export function formatAudioDiagnostics(blob, durationMs) {
  const seconds = (durationMs / 1000).toFixed(1);
  const kib = (blob.size / 1024).toFixed(1);
  return `${seconds}s • ${kib} KiB • ${blob.type || 'unknown format'}`;
}
